module.exports = {
  // Types of comparison metrics
  ComparisonMetricTypes: {
    nearbyStations: 'Nearby Stations',
    priorPeriod: 'Prior Period',
    myStations: 'My Stations',
    otherStationList: 'Other Station List',
    brand: 'Brand',
    industry: 'Industry Average',
  },

  // Types of brand regions
  BrandRegionTypes: {
    national: 'National Competition',
    regional: 'Regional Competition',
  },

  RatingScoreLabels: {
    good: 'good',
    average: 'average',
    poor: 'poor',
    none: 'none',
  },

  Solutions: {
    Listings: 'listings',
    ReputationManagement: 'reputation-management',
    Insights: 'insights',
  },

  Roles: {
    Administrator: 'administrator',
    Editor: 'editor',
    Observer: 'observer',
    Fuel_Shortage: 'fuel_shortage',
  },

  StationListResponseType: {
    no_stations: 'no_stations',
    stations_without_address: 'stations_without_address',
    stations_with_address: 'stations_with_address',
    full_stations: 'full_stations',
    only_station_ids: 'only_station_ids',
  },
};
